module.exports = __webpack_public_path__ + "img/BE0415718640.0c1c2f9f.png";